export default __webpack_public_path__ + "static/button-play-8dc1e7c837d1e0e85da7cb40c8de1424.png";